module.exports = __webpack_public_path__ + "img/service_img02.fa5af829.png";